<p>list-stat-reponse works!</p>
